import { Session } from './session.model';
import { UserMapper } from 'app/user/user.mapper';
import { SessionSurveyMapper } from './session-survey.mapper';

export class SessionMapper {
  public static map(sessionData: any): Session {
    if (!sessionData) {
      return null;
    }

    return new Session(
        sessionData.id,
        sessionData.name,
        sessionData.status,
        sessionData.type,
        sessionData.deletable,
        sessionData.startDate,
        sessionData.endDate,
        sessionData.sessionItem.map(SessionSurveyMapper.map),
        sessionData.coaches ? sessionData.coaches.map(UserMapper.map) : null,
        sessionData.participants ? sessionData.participants.map(UserMapper.map) : null
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/session/session.mapper.ts